import LangContext from './LangContext'

export const LangConsumer = LangContext.Consumer ;

export default LangConsumer ;